import request from '../index.js';

// 菜单列表
export const menuList = (query) => {
  return request({
      url: '/menu/getMenuList',
      method: 'GET',
      data: query
  })
}
// 删除菜单
export const delMenu = (query) => {
  return request({
      url: '/menu/deleteMenuById',
      method: 'DELETE',
      params: query
  })
}
// 添加菜单
export const addMenu = (query) => {
  return request({
      url: '/menu/addMenu',
      method: 'POST',
      data: query
  })
}
// 修改菜单
export const alterMenu = (query) => {
  return request({
      url: '/menu/updateMenu',
      method: 'PUT',
      data: query
  })
}
// 部门列表
export const deptList = (query) => {
  return request({
      url: '/dept/getDeptList',
      method: 'POST',
      data: query
  })
}
// 删除部门
export const delDept = (query) => {
  return request({
      url: '/dept/deleteDeptById',
      method: 'DELETE',
      params: query
  })
}
// 添加部门
export const addDept = (query) => {
  return request({
      url: '/dept/addDept',
      method: 'POST',
      data: query
  })
}
// 修改部门
export const alterDept = (query) => {
  return request({
      url: '/dept/updateDept',
      method: 'PUT',
      data: query
  })
}
// 角色列表
export const roleList = (query) => {
  return request({
      url: '/role/getRoleList',
      method: 'POST',
      data: query
  })
}
// 删除角色
export const delRole = (query) => {
  return request({
      url: '/role/deleteRoleById',
      method: 'DELETE',
      params: query
  })
}
// 添加角色
export const addRole = (query) => {
  return request({
      url: '/role/addRole',
      method: 'POST',
      data: query
  })
}
// 修改角色
export const alterRole = (query) => {
  return request({
      url: '/role/updateRole',
      method: 'PUT',
      data: query
  })
}
// 检查角色
export const checkRole = (query) => {
  return request({
      url: '/role/check',
      method: 'GET',
      params: query
  })
}
// 用户列表
export const userList = (query) => {
  return request({
      url: '/user/getUserList',
      method: 'POST',
      data: query
  })
}
// 删除用户
export const delUser = (query) => {
  return request({
      url: '/user/deleteUserById',
      method: 'DELETE',
      params: query
  })
}
// 添加用户
export const addUser = (query) => {
  return request({
      url: '/user/addUser',
      method: 'POST',
      data: query
  })
}
// 修改用户
export const alterUser = (query) => {
  return request({
      url: '/user/updateUser',
      method: 'PUT',
      data: query
  })
}
// 用户链路权限
export const addUserLinePermission = (query) => {
  return request({
      url: '/iotLine/addUserLinePermission',
      method: 'POST',
      data: query
  })
}
// 用户密码重置
export const pwdReset = (query) => {
  return request({
      url: '/user/password/reset',
      method: 'PUT',
      params: query
  })
}
// 登录日志列表
export const loginLogList = (query) => {
  return request({
      url: '/loginLog/getLoginLogList',
      method: 'POST',
      data: query
  })
}
// 登录日志删除
export const loginLogDel = (query) => {
  return request({
      url: '/loginLog/deleteLogs',
      method: 'DELETE',
      params: query
  })
}
// 操作日志列表
export const operateLogList = (query) => {
  return request({
      url: '/log/getLogList',
      method: 'POST',
      data: query
  })
}
// 操作日志删除
export const operateLogDel = (query) => {
  return request({
      url: '/log/deleteLogs',
      method: 'DELETE',
      params: query
  })
}